import { getFirestore, doc, getDoc, DocumentReference, collection } from 'firebase/firestore';
import type { CollectionReference, DocumentData } from 'firebase/firestore';
import { getFirebaseApp } from '../../config/firebase.config';

export class FirestoreConnection {


  static getCollection(collectionName: string, ...collectionNames: string[]): CollectionReference {
    const db = getFirestore(getFirebaseApp());
    return collection(db, collectionName, ...collectionNames);
  }

  static getDocumentReference(collectionName: string, documentId: string, ...collectionNames: string[]): DocumentReference {
    const db = getFirestore(getFirebaseApp());
    return doc(db, collectionName, documentId, ...collectionNames);
  }

  /** path（例: `admin_accounts/abc123`）から DocumentReference を返す */
  static getDocumentReferenceByPath(path: string): DocumentReference {
    const db = getFirestore(getFirebaseApp());
    const parts = path.split('/').filter(Boolean);
    if (parts.length < 2) {
      throw new Error(`Invalid document path (expected collection/id): ${path}`);
    }
    return doc(db, parts[0], parts[1], ...parts.slice(2)) as DocumentReference;
  }

  static async get<T extends DocumentData>(docRef: DocumentReference): Promise<(T & { documentId: string }) | null> {
    try {
      const docSnap = await getDoc(docRef);
      
      if (!docSnap.exists()) {
        return null;
      }

      return {
        documentId: docSnap.id,
        ...docSnap.data()
      } as T & { documentId: string };
    } catch (error) {
      console.error('Error getting document:', error);
      throw error;
    }
  }
} 